"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WordSlowResponseNotice = exports.WORD_SLOW_RESPONSE_SHOWN_EVENT = exports.WORD_SLOW_RESPONSE_MESSAGE = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _useWordResponsiveness = require("../../hooks/use-word-responsiveness");
var _Banner = _interopRequireDefault(require("./Banner"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var WORD_SLOW_RESPONSE_MESSAGE = exports.WORD_SLOW_RESPONSE_MESSAGE = "Word is taking longer than usual to respond. Low memory or many open apps and documents on this computer can slow Word. Closing other apps and documents usually helps, and your work will continue once Word responds.";
var WORD_SLOW_RESPONSE_SHOWN_EVENT = exports.WORD_SLOW_RESPONSE_SHOWN_EVENT = "word_slow_response_shown";
var WordSlowResponseNotice = exports.WordSlowResponseNotice = function WordSlowResponseNotice(_ref) {
  var surface = _ref.surface,
    tracker = _ref.tracker;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  var _useWordResponsivenes = (0, _useWordResponsiveness.useWordResponsiveness)(tracker),
    isSlow = _useWordResponsivenes.isSlow,
    oldestCallAgeMsWhenSlow = _useWordResponsivenes.oldestCallAgeMsWhenSlow;
  (0, _react.useEffect)(function () {
    if (!isSlow) return;
    analytics === null || analytics === void 0 || analytics.track(WORD_SLOW_RESPONSE_SHOWN_EVENT, {
      surface: surface,
      oldestCallAgeMs: oldestCallAgeMsWhenSlow
    });
  }, [isSlow, analytics, surface, oldestCallAgeMsWhenSlow]);
  if (!isSlow) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    role: "status",
    "aria-live": "polite",
    "data-sentry-component": "WordSlowResponseNotice",
    "data-sentry-source-file": "WordSlowResponseNotice.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Banner.default, {
      type: "warning",
      message: WORD_SLOW_RESPONSE_MESSAGE,
      "data-sentry-element": "Banner",
      "data-sentry-source-file": "WordSlowResponseNotice.tsx"
    })
  });
};